import { Injectable } from '@angular/core';
@Injectable()
export class notificationStatus {
  public Status: any[] = [
    { value: 'ACTIVE', name: 'Activo' },
    { value: 'INACTIVE', name: 'Inactivo' }
  ];

  constructor() { }
}

@Injectable()
export class notificationType {
  public dbtType: Record<string, string>[] = [
    { value: 'EMAIL', name: 'EMAIL' },
    { value: 'WHATSAPP', name: 'WHATSAPP' },
    { value: 'SMS', name: 'SMS' }
  ];

  constructor() { }
}

export const notificationsTemplateStatusV2: notificationTemplateStatusV2[] = [
  { label: 'Activo', value: 'ACTIVE', cssClass: 'new-active-color-status' },
  { label: 'Inactivo', value: 'INACTIVE', cssClass: 'new-inactive-color-status' }
];

export interface notificationTemplateStatusV2 {
  label:      'Activo' | 'Inactivo';
  value:      'ACTIVE' | 'INACTIVE';
  cssClass:   string;
}
